<template>
  <div>
    <OpsMetrics :formattedMetrics="formattedMetrics" :metrics="metrics" :reviewData="reviewData" :accountsData="accountsData" />
  </div>
</template>

<script>
import OpsMetrics from '../ops_metrics.vue';
export default {
  name: 'AdminDashboard',
  props: {
    metrics: {
      type: Array,
      required: true
    },
    reviewData: {
      type: Array,
      required: true
    },
    accountsData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formattedMetrics: []
    }
  },
  components: {
    OpsMetrics
  },
  methods: {
    formatMetrics(metrics) {
      this.$set(this, 'formattedMetrics', []);
      this.$set(this.formattedMetrics, 0, {
        title: 'PDA',
        open: metrics.map(metric => metric.open_pda).reduce((acc, num) => acc + num, 0),
        overdue: metrics.map(metric => metric.overdue_pda).reduce((acc, num) => acc + num, 0),
      });
      this.$set(this.formattedMetrics, 1, {
        title: 'Jobs',
        open: metrics.map(metric => metric.open_fda).reduce((acc, num) => acc + num, 0),
        ops_overdue: metrics.map(metric => metric.ops_overdue_fda).reduce((acc, num) => acc + num, 0),
        manager_overdue: metrics.map(metric => metric.manager_overdue_fda).reduce((acc, num) => acc + num, 0),
      });
      this.$set(this.formattedMetrics, 2, {
        title: 'Review Requested',
        open: metrics.map(metric => metric.review_requested).reduce((acc, num) => acc + num, 0),
        overdue: metrics.map(metric => metric.manager_overdue_review_requested).reduce((acc, num) => acc + num, 0),
      });
      this.$set(this.formattedMetrics, 3, {
        title: 'Billing',
        open: metrics.map(metric => metric.billing).reduce((acc, num) => acc + num, 0),
        overdue: metrics.map(metric => metric.billing_overdue).reduce((acc, num) => acc + num, 0),
      });
    }
  },
  watch: {
    metrics: {
      handler(newVal) {
        this.formatMetrics(newVal);
      },
      deep: true
    }
  },
  created() {
    this.formatMetrics(this.metrics);
  }
}
</script>